<template>
    <v-dialog
            v-model="state.activator"
            persistent
            width="300"
    >
        <v-card
                class="rounded-light"
                color="primary"
                dark
        >
            <v-card-text>
                {{ state.message }}
                <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                />
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
    export default {
        name: "GlobalLoader",
        props: ["state"],
        data() {
            return {};
        },
        methods: {
            shutdown() {
                let newState = {
                    activator: false,
                    message: "",
                };
                this.$store.dispatch("AppState/setGlobalLoaderState", newState);
            },
        },
    };
</script>
